import { EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Component, OnInit, Input,Output} from '@angular/core';
import { catchError } from 'rxjs/operators';
import { BaseComponent } from '../../pages/base/base.component';
import { RestService } from '../../services/rest.service';


//Asi de culero esta en el ws, vamos a poner este tal cual
interface ComexClient
{
	loginName:string; //Numero de tarjeta
	password:string; //
	//userType:string;
	//loginLocation:string;
	nombre:string;
	apellidoPaterno:string;
	apellidoMaterno:string;
	estadoCivil:string;
	eMail:string;
	pais:string;
	sexo:string;
	fechaNacimiento:string;
	telefonoCasa:string;
	telefonoOficina:string;
	celular:string;
	calle:string;
	numeroExterior:string;
	numeroInterior:string;
	colonia:string;
	municipio:string;
	estado:string;
	ciudad:string;
	codigoPostal:string;
	positionTitle:string;
	ocupacion:string;
	otraOcupacion:string;
	compania:string;
	activationKey:string;
	externalId:string;
	contactoTel:string;
	contactoMail:string;
	contactoDireccion:string;
	Operatel:string;
	rfc:string;
	client_user_id:number;
}


@Component({
	selector: 'app-comex-client',
	templateUrl: './comex-client.component.html',
	styleUrls: ['./comex-client.component.css']
})
export class ComexClientComponent extends BaseComponent implements OnInit, OnChanges
{
	@Input() client_user_id:number = 0;
	@Output() newClientEvent:EventEmitter<any> = new EventEmitter();


	comex_client:ComexClient = this.getEmptyComexClient();

	ngOnInit(): void
	{

	}

	ngOnChanges(changes: SimpleChanges): void
	{
		console.log('Changes', changes );
    }

	getEmptyComexClient():ComexClient
	{
		return {
			loginName:'', //Numero de tarjeta
			password:'', //
			nombre:'',
			apellidoPaterno:'',
			apellidoMaterno:'',
			estadoCivil:'',
			eMail:'',
			pais:'',
			sexo:'',
			fechaNacimiento:'',
			telefonoCasa:'',
			telefonoOficina:'',
			celular:'',
			calle:'',
			numeroExterior:'',
			numeroInterior:'',
			colonia:'',
			municipio:'',
			estado:'',
			ciudad:'',
			codigoPostal:'',
			positionTitle:'',
			ocupacion:'',
			otraOcupacion:'',
			compania:'',
			activationKey:'',
			externalId:'',
			contactoTel:'',
			contactoMail:'',
			contactoDireccion:'',
			Operatel:'',
			rfc:'',
			client_user_id:this.client_user_id
		}
	}


	save(evt:Event)
	{
		evt.preventDefault();
		console.log("Guardando...");
		this.is_loading = true;

		this.comex_client.client_user_id = this.client_user_id;

		this.sink = this.rest.comex('user', this.comex_client)
		.pipe
		(
			catchError((error)=>
			{
				let safe_error = safeStringify(error);
				if(
					safe_error.indexOf('ERR_CLIENTE_EXISTS') > -1  ||
					safe_error.indexOf('ERR_EMAIL_EXISTS') > -1  ||
					safe_error.indexOf('ERR_CELLULAR_EXISTS') > -1
				)
				{
					let request = { user_id: this.client_user_id, phone: this.comex_client.celular };
					return this.rest.comex('assign_user_by_phone', request );
				}

				throw error;
			})
		)
		.subscribe
		({
			next: (data:any)=>
			{
				console.log(data);
				this.is_loading = false;
				this.newClientEvent.emit( true );
			},
			error: (error:any)=>
			{
				console.log(error);
				this.is_loading = false;
				this.showError( error );
			}
		});
	}
}


function safeStringify(obj) {
	const seen = new WeakSet();

	return JSON.stringify(obj, function (key, value) {
		// Handle circular references
		if (typeof value === "object" && value !== null)
		{
			if (seen.has(value)) {
				return "[Circular]";
			}
			seen.add(value);
		}

		// Convert special browser objects
		if (value === window) return "[Window]";
		if (value === document) return "[Document]";
		if (value instanceof Element) return "[DOM Element]";

		// Convert unsupported types
		if (typeof value === "function") return "[Function]";
		if (typeof value === "undefined") return null;
		if (typeof value === "bigint") return value.toString();

		// Convert Map
		if (value instanceof Map)
		{
			return Object.fromEntries(value);
		}

		// Convert Set
		if (value instanceof Set)
		{
			return Array.from(value);
		}

		return value;
	});
}
